// extracted by mini-css-extract-plugin
export var addButton = "_e5-0";
export var border = "_e5-8";
export var check = "_e5-h";
export var danger = "_e5-6";
export var dropdownContainer = "_e5-1";
export var editModalBody = "_e5-j";
export var footerContainer = "_e5-i";
export var fullWidth = "_e5-a";
export var hide = "_e5-9";
export var icon = "_e5-3";
export var input = "_e5-7";
export var inputFlex = "_e5-b";
export var inputWrapper = "_e5-c";
export var manualFocus = "_e5-5";
export var optionButton = "_e5-4";
export var pillWrapper = "_e5-e";
export var pointer = "_e5-2";
export var showOverflow = "_e5-f";
export var tagsFlex = "_e5-d";
export var xButton = "_e5-g";